module.exports = __webpack_public_path__ + "img/l.f456329a.gif";